// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"US-z","inlineTitle":"VS-z","sponsoredAdsWrapper":"WS-z","marketplaceRecosWrapper":"XS-z"};